var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "voiceSceneTeacherDetail" } }, [
    _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "btn-box" }, [
        _c("div", [
          _vm.preId
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.queryGrade(_vm.preId)
                    }
                  }
                },
                [_vm._v("上一通练习")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.nextId
            ? _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.queryGrade(_vm.nextId)
                    }
                  }
                },
                [_vm._v("下一通练习")]
              )
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bottom" }, [
      _c("div", { staticClass: "header" }, [_vm._v("练习得分与建议")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content wx" },
        [
          _c("div", { staticClass: "video" }, [
            _c("span", [_vm._v("练习录音")]),
            _vm._v(" "),
            _c("audio", { attrs: { src: _vm.videoUrl, controls: "controls" } })
          ]),
          _vm._v(" "),
          _vm.effectStatus == 0
            ? [
                _c("div", { staticClass: "text-box" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", [_vm._v("练习无效")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "wuxiao" }, [
                    _vm._v(_vm._s(_vm.effectReason))
                  ])
                ])
              ]
            : _vm.effectStatus == 1
            ? [
                _c(
                  "div",
                  { staticClass: "score" },
                  [
                    _c("div", { staticClass: "title" }, [
                      _c("span", [_vm._v("练习得分")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "blue" }, [
                        _vm._v(_vm._s(_vm.gradeScore) + "分")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.gradeList, function(f, index) {
                      return _c(
                        "div",
                        { staticClass: "grade" },
                        [
                          _c("div", { staticClass: "first" }, [
                            _c("span", { staticClass: "name" }, [
                              _vm._v(_vm._s(f.name))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "blue gradescore" }, [
                              _vm._v(_vm._s(f.gradeScore) + "分")
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(f.childList, function(s, key) {
                            return _c(
                              "div",
                              { staticClass: "second" },
                              [
                                _c("div", { staticClass: "parent" }, [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(s.name))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "red gradescore" },
                                    [_vm._v(_vm._s(s.gradeScore) + "分")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    key: key + _vm.keyData,
                                    class: {
                                      "el-icon-arrow-right": !s.isClickSecond,
                                      "el-icon-arrow-down": s.isClickSecond
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.clickSecond(index, key)
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _vm._l(s.childList, function(t, key) {
                                  return _c(
                                    "div",
                                    {
                                      key: key + _vm.keyData,
                                      class: {
                                        third: true,
                                        none: !s.isClickSecond
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(t.name))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "red gradescore" },
                                        [_vm._v(_vm._s(t.gradeScore) + "分")]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "evaluate" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._l(_vm.evaluateList, function(e, key) {
                      return _c("p", [
                        _c("span", { staticClass: "dot" }),
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(key + 1) +
                            "、" +
                            _vm._s(e) +
                            "\n\t\t\t\t\t\t"
                        )
                      ])
                    })
                  ],
                  2
                )
              ]
            : [_vm._m(2)]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        attrs: { src: require("@/assets/images/voiceScene/icon_wuxiao.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("练习建议")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-box" }, [
      _c("p", [
        _c("img", {
          attrs: { src: require("@/assets/images/voiceScene/icon_dafen.png") }
        })
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("待评分")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-636e8117", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-636e8117","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/newVoiceScene/teacherDetail.vue
// module id = 1524
// module chunks = 0